module.exports = __webpack_public_path__ + "img/file.c23fe5b8.png";